export default function ToggleSwitch({ checked, onChange, disabled }) {
  return (
    <label className="toggle-wrapper" style={disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}>
      <input
        type="checkbox"
        className="toggle-checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <div className="toggle-switch">
        <div className="toggle-slider"></div>
      </div>
    </label>
  );
}
